import React, {useContext, useState, useEffect} from 'react'
import { auth, database } from '../firebase'

const AuthContext = React.createContext()

export function useAuth() {
    return useContext(AuthContext)
}

export function AuthProvider({ children }) {
    const [currentUser, setCurrentUser] = useState()
    const [loading, setLoading] = useState(true)

    function signup(email, password){
        return auth.createUserWithEmailAndPassword(email, password)
    }

    function login(email, password){
        return auth.signInWithEmailAndPassword(email, password)
    }

    function logout() {
        return auth.signOut()
    }

    function resetPassword(email) {
      return auth.sendPasswordResetEmail(email)
    }

    function addDetails(company, phoneNum){
        const info = {
            information : {
                company,
                phoneNum
            }
        }
        auth.currentUser.updateProfile({displayName: company, photoURL: phoneNum})
        return database.ref(auth.currentUser.uid).update(info)
    }

    function addCart(item, quant, notes){
        var uid = auth.currentUser.uid
        const itemed = {
            item,
            quant,
            notes
        }      
        return database.ref(`/${uid}/cart`).push(itemed)
    }

    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged(user => {
            setCurrentUser(user)
            setLoading(false)
        })         
        return unsubscribe
    }, [])

    const value = {
        currentUser,
        logout,
        login,
        signup,
        resetPassword,
        addDetails,
        addCart
    }
    return (
        <AuthContext.Provider value={value}>
            {!loading && children}
        </AuthContext.Provider>
    )
}